export enum SearchStorageKeys {
  SEARCH_RECENT_PRODUCTS_STORE_KEY = 'searchRecentProductsHistory',
  SEARCH_QUERIES_STORE_KEY = 'searchQueriesHistory',
}
